export const getFirstName = (username: string) => {
  const splittedUsername = username.split(" ")
  return splittedUsername.length === 1
    ? splittedUsername[0]
    : splittedUsername.slice(0, -1).join(" ")
}
